import React, { memo } from 'react'
import { randomNum } from '@utils'
import './index.scss'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  /** 宽 */
  width: number;
  /** 高 */
  height?: number;
  /** 图片url */
  imgSrc?: string;
}

const icons: string[] = ['icon-a-162', 'icon-dangao', 'icon-haiyangyuyuye', 'icon-jitui', 'icon-shuiguo3yy', 'icon-miantiao', 'icon-chashuiyinliao', 'icon-yinliao', 'icon-a-161', 'icon-a-16']

const OrderProductImg: React.FC<IProps> = ({ width, imgSrc, className, height, color, ...others }) => {
  const imageHeight = height || width
  const icon: string = icons[randomNum(0, icons.length - 1)]

  return (
    <div
      className='order-product-image'
      style={{
        width,
        height: imageHeight,
        backgroundImage: imgSrc ? `url(${imgSrc})` : 'none',
      }}
      {...others}
    >
      {
        !imgSrc && <i className={`iconfont ${icon}`}></i>
      }
    </div>
  )
}

export default memo(OrderProductImg)
